import { render, staticRenderFns } from "./access-manager.vue?vue&type=template&id=23611324&scoped=true"
var script = {}
import style0 from "./access-manager.vue?vue&type=style&index=0&id=23611324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23611324",
  null
  
)

export default component.exports